import React, { useState } from 'react';
import './ContactUs.css';

const ContactForm = () => {
  const [budget, setBudget] = useState(5000);
  const [submitStatus, setSubmitStatus] = useState('');

  const offices = [
    {
      country: 'Canada',
      flag: '🇨🇦',
      address:
        '43 Baby Pointe Trail, Brampton, ON L7A 0W1',
    },
    {
      country: 'India',
      flag: '🇮🇳',
      address:
        'F-352, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit Singh Nagar, Punjab 140308',
    },
  ];

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitStatus('sending');

    const form = event.currentTarget;
    const formData = new FormData(form);
    formData.set('form-name', 'contact');

    try {
      const response = await fetch(window.location.pathname, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString(),
      });

      if (!response.ok) {
        throw new Error(`Form submission failed: ${response.status}`);
      }

      form.reset();
      setBudget(5000);
      setSubmitStatus('success');
      window.setTimeout(() => {
        window.location.assign('/thank-you');
      }, 700);
    } catch (error) {
      setSubmitStatus(error.message || 'error');
    }
  };

  return (
    <section className="snow-contact" id="contact">
      <div className="snow-contact-inner">
        <div className="snow-section-header">
          <span className="snow-section-label">❆ Get In Touch</span>
          <h2 className="snow-section-title">Let's Build Something Amazing Together</h2>
        </div>

        <div className="snow-contact-grid">
          {/* Left — Contact Info */}
          <div className="snow-contact-info">
            <h3 className="snow-contact-info-title">Contact Info</h3>
            <p className="snow-contact-info-desc">
              Contact us by filling out the form or reach out to us directly via
              email or phone. Our team will get back to you as soon as possible.
            </p>

            <div className="snow-contact-details">
              <div className="snow-contact-detail">
                <span className="snow-contact-detail-icon">📞</span>
                <div>
                  <div className="snow-contact-detail-label">Phone</div>
                  <div className="snow-contact-detail-value">+1 647-334-9760 | +1 647-334-9759</div>
                </div>
              </div>
              <div className="snow-contact-detail">
                <span className="snow-contact-detail-icon">✉️</span>
                <div>
                  <div className="snow-contact-detail-label">Email</div>
                  <div className="snow-contact-detail-value">sales@snowtechlabs.com</div>
                </div>
              </div>
            </div>

            <h4 className="snow-offices-title">Office Locations</h4>
            <div className="snow-offices-list">
              {offices.map((office, index) => (
                <div key={index} className="snow-office-item">
                  <span className="snow-office-flag">{office.flag}</span>
                  <div>
                    <div className="snow-office-country">{office.country}</div>
                    <div className="snow-office-address">{office.address}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Form */}
          <div className="snow-contact-form-wrap">
            <h3 className="snow-contact-form-title">Let's Talk</h3>
            <form
              className="snow-contact-form"
              name="contact"
              method="POST"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              onSubmit={handleSubmit}
            >
              <input type="hidden" name="form-name" value="contact" />
              <input type="hidden" name="bot-field" />
              <div className="snow-form-row">
                <div className="snow-form-group">
                  <label className="snow-form-label">Your Name</label>
                  <input name="name" type="text" className="snow-form-input" placeholder="John Doe" required />
                </div>
                <div className="snow-form-group">
                  <label className="snow-form-label">Your Email</label>
                  <input name="email" type="email" className="snow-form-input" placeholder="john@example.com" required />
                </div>
              </div>

              <div className="snow-form-group">
                <label className="snow-form-label">Company Name</label>
                <input name="company" type="text" className="snow-form-input" placeholder="Your Company" />
              </div>

              <div className="snow-form-group">
                <label className="snow-form-label">Phone Number</label>
                <input name="phone" type="tel" className="snow-form-input" placeholder="+1 (555) 000-0000" />
              </div>

              <div className="snow-form-group">
                <label className="snow-form-label">Message</label>
                <textarea name="message" className="snow-form-textarea" rows="4" placeholder="Tell us about your project..." required></textarea>
              </div>

              <div className="snow-form-group">
                <label className="snow-form-label">Budget: ${budget.toLocaleString()}</label>
                  <input
                    name="budget"
                  type="range"
                  className="snow-form-range"
                  min="1000"
                  max="20000"
                  step="500"
                  value={budget}
                  onChange={(e) => setBudget(parseInt(e.target.value))}
                />
                <div className="snow-range-labels">
                  <span>$1,000</span>
                  <span>$20,000</span>
                </div>
              </div>

              <label className="snow-checkbox-label">
                <input name="nda" type="checkbox" className="snow-checkbox" />
                <span className="snow-checkbox-custom"></span>
                I want to protect my business idea by signing an NDA
              </label>

              <button type="submit" className="snow-submit-btn" disabled={submitStatus === 'sending'}>
                {submitStatus === 'sending' ? (
                  <>
                    <span className="snow-submit-spinner" aria-hidden="true"></span>
                    <span>Sending...</span>
                  </>
                ) : (
                  <>
                    <span>Send Message</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M2 8L14 2L8 14L7 9L2 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                    </svg>
                  </>
                )}
              </button>
              {submitStatus === 'success' && (
                <p className="snow-form-status success" role="status">
                  Thanks, your message has been sent.
                </p>
              )}
              {submitStatus && submitStatus !== 'sending' && submitStatus !== 'success' && (
                <p className="snow-form-status error" role="alert">
                  We could not send your message. Please try again. ({submitStatus})
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
